import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import '../utils/PanelPrincipal.css'; 
import logo from '../components/public/llave.jpg';
import logo1 from '../components/public/user.png';

//const API_URL_USUARIOS = process.env.REACT_APP_API_URL + '/usuarios';
const API_URL_USUARIOS = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/usuarios` 
  : 'http://localhost:4000/usuarios';
//const API_URL = process.env.REACT_APP_API_URL;
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';


const PanelPrincipal = () => {
  const [user, setUser] = useState(null);
  const [nombreAplicacion, setNombreAplicacion] = useState(null);
  const [tarifaData, setTarifaData] = useState({
    tarifa_base: 0,
    valor_base: 0,
    tarifa_exceso: 0,
    porcentaje_mora: 0,
    monto_registro_socio: 0,
    monto_reconexion: 0,
    nombre_aplicacion: ''
  });
  const [showMenu, setShowMenu] = useState(false);
  const [showDefaultContent, setShowDefaultContent] = useState(true);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [username, setUsername] = useState('');  // Estado para el nombre de usuario
  const [password, setPassword] = useState('');  // Estado para la contraseña
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarVisible, setSidebarVisible] = useState(true);
  
  const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };
  
  const fetchUserProfile = async () => {
    try {
      const userId = localStorage.getItem('id_usuario'); // Asegúrate de guardar esto en el login
      if (!userId) return navigate('/');
  
      const headers = getAuthHeaders();
      const response = await axios.get(`${API_URL}/usuarios/${userId}`, { headers });
  
      if (response.data) {
        setUser({ nombre: response.data.nombre });
      } else {
        navigate('/');
      }
    } catch (error) {
      console.error('Error fetching user profile:', error);
      navigate('/');
    }
  };
  


  useEffect(() => {
    const storedName = localStorage.getItem('nombre');
    
    if (storedName) {
      setUser((prevUser) => ({
        ...prevUser,
        nombre: storedName,  
      }));
    }

    const fetchTarifaData = async () => {
      try {
        const response = await axios.get(`${API_URL}/tarifas`);
        if (response.data.length > 0) {
          const data = response.data[0];
          setTarifaData({
            tarifa_base: data.tarifa_base,
            valor_base: data.valor_base,
            tarifa_exceso: data.tarifa_exceso,
            porcentaje_mora: data.porcentaje_mora,
            monto_registro_socio: data.monto_registro_socio,
            monto_reconexion: data.monto_reconexion,
            nombre_aplicacion: data.nombre_aplicacion
          });
        }
      } catch (error) {
        console.error('Error fetching tarifas data:', error);
      }
    };

    fetchTarifaData();
    fetchUserProfile();
  }, []);

  useEffect(() => {
    setShowDefaultContent(location.pathname === '/panel');
  }, [location.pathname]);

  const handleLogout = () => {
    if (window.confirm('¿Estás seguro de que quieres cerrar sesión?')) {
      localStorage.removeItem('token');
      localStorage.removeItem('nombre');
      localStorage.removeItem('id_usuario');
      localStorage.removeItem('rol_usuario');
      setUser(null);
      setShowMenu(false);
      navigate('/');
    } else {
      setShowMenu(false);
    }
  };  

  const toggleMenu = () => {
    setShowMenu(prevShowMenu => !prevShowMenu);
  };

  const handleMenuClick = (path) => {
    const fullPath = `/panel${path}`;
    
    if (location.pathname.startsWith('/panel')) {
      if (window.confirm('¿Estás seguro de que quieres cambiar de sección?')) {
        setPendingNavigation(fullPath);
        setShowMenu(false);
      } else {
        setShowMenu(false); 
      }
    } else {
      navigate(fullPath);
      setShowMenu(false);
    }
  };

  useEffect(() => {
    if (pendingNavigation) {
      navigate(pendingNavigation);
      setPendingNavigation(null);
    }
  }, [pendingNavigation, navigate]);

  const handleInicioClick = () => {
    setShowDefaultContent(true);
    navigate('/panel');
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/login', {  // Usa la variable de entorno
      //const response = await axios.post('http://localhost:4000/login', {
        usuario: username,
        contrasena: password,
      });
      if (response.data) {
        const data = response.data;
        setUser({
          username: data.usuario,  
          nombre: data.nombre,  
        });
        localStorage.setItem('nombre', data.nombre);
        localStorage.setItem('cedula', data.codigo);
        localStorage.setItem('token', response.data.token);  
      }
    } catch (error) {
      console.error('Error durante el inicio de sesión:', error);
      alert('Usuario o contraseña incorrectos');
    }
  };

  return (
    <div className="panel-principal">
      <div className={`sidebar ${sidebarVisible ? 'visible' : 'hidden'}`}>

          <div className="profile-image">
          <img className="img-xs rounded-circle" src={logo1} alt="profile" />
          <div className="dot-indicator bg-success"></div>
        </div>
          <div className="text-wrapper">
            <p className="profile-name">Usuario:  {user?.nombre || 'nombre'} </p>
          </div>
        <ul>
          <li><a onClick={handleInicioClick}>Inicio</a></li>
          <li><a onClick={() => handleMenuClick('/clientes')}>Clientes</a></li>
          <li><a onClick={() => handleMenuClick('/tarifas')}>Tarifas</a></li>
          <li><a onClick={() => handleMenuClick('/medidores')}>Medidores</a></li>
          <li><a onClick={() => handleMenuClick('/consumos')}>Consumos</a></li>
          <li><a onClick={() => handleMenuClick('/pagos')}>Pagos</a></li>
          <li><a onClick={() => handleMenuClick('/reportes')}>Reportes</a></li>
          <li><a onClick={() => handleMenuClick('/rendicioncuentas')}>Libro Contable</a></li>
        </ul>
      </div>
      <div className={`content ${sidebarVisible ? '' : 'expanded'}`}>
        <div className="header">
          <div className="header-right">
          <button className="toggle-sidebar" onClick={() => setSidebarVisible(!sidebarVisible)}>
          ☰ </button>
          <h3>{tarifaData.nombre_aplicacion}</h3>
          </div>
          <div className="header-left">
            <button className="profile-button" onClick={toggleMenu}>
              {user?.nombre || 'Perfil del Usuario'}
            </button>

            {showMenu && (
              <div className="dropdown-menu">
                <button onClick={() => handleMenuClick('/perfil-usuario')}>Ver perfil</button>
                <button onClick={() => handleMenuClick('/usuarios')}>Agregar usuario</button>
                <button onClick={handleLogout}>Cerrar sesión</button>
              </div>
            )}
          </div>
        </div>
        <div className="main-content">
          {showDefaultContent && (
            <>
              <section className="intro-section">
                <div className="intro-text">
                  <h2>Valores base del servicio:</h2>
                </div>
                <div className="intro-image">
                  <img src={logo} alt="Logo" />
                </div>
              </section>
              <div className="stats">
                <div className="stat">
                  <h3>{tarifaData.tarifa_base}m³</h3>
                  <p>Tarifa Base</p>
                </div>
                <div className="stat">
                  <h3>${tarifaData.valor_base}</h3>
                  <p>Valor de la Base</p>
                </div>
                <div className="stat">
                  <h3>${tarifaData.tarifa_exceso}</h3>
                  <p>Adicional por m³</p>
                </div>
                <div className="stat">
                  <h3>{tarifaData.porcentaje_mora}</h3>
                  <p>Valor de Mora $</p>
                </div>
              </div>
              <div className="titulo">
                <h2>Valores adicionales del servicio:</h2>
              </div>
              <div className="stats1">
                <div className="stat1">
                  <h3>${tarifaData.monto_registro_socio}</h3>
                  <p>Costo por nuevos socios</p>
                </div>
                <div className="stat1">
                  <h3>${tarifaData.monto_reconexion}</h3>
                  <p>Costo por reconexión</p>
                </div>
              </div>
            </>
          )}
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PanelPrincipal;
